<template>
    <div class="modal fade" id="inactivityModal" tabindex="-1" aria-labelledby="inactivityModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered popOutModal">
            <div class="modal-content">
                <div class="modal-body d-flex flex-column py-4 align-items-center justify-content-between">
                    <i class="bi bi-power w-auto h-auto fs-large"></i>
                    <p class="my-2 text-secondary text-center">You will be logged out in {{ timeString }} due to inactivity.</p>
	                <p class="my-2 text-secondary text-center">Click the button below to stay logged in.</p>
                    <div class="mt-3 d-flex gap-3">
                        <button class="btn py-7 btn-dark" v-ripple @click="keepUserLoggedIn" >Stay Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, computed, watch, onUnmounted } from 'vue';
import Modal from "bootstrap/js/dist/modal";
import { useAuthStore } from "@/stores/auth-store.js";

const props = defineProps({
    timeLeft: Number,
});

const emits = defineEmits(['closeModal']);
const modal = ref(null);
const auth = useAuthStore();

const timer = ref(props.timeLeft ? props.timeLeft : 1800);
watch(timer, async (val) => {
	if(val <= 0) {
		await auth.processLogout();
		await close();
	}
});

const timeString = computed(() => {
	if (timer.value > 60) {
		return Math.ceil(timer.value / 60) + ' minutes';
	}
	return Math.ceil(timer.value) + ' seconds';
});

const timerInterval = ref(null);
onMounted(() => {
    var modalEl = document.getElementById('inactivityModal');
    modal.value = Modal.getOrCreateInstance(modalEl, {
	    backdrop: 'static',
	    keyboard: false
    });
    modal.value.show();

    modalEl.addEventListener('hide.bs.modal', function (event) {
	    emits('closeModal');
        modalEl.querySelector('.modal-dialog').classList.add('closing');
        setTimeout(() => {
            modalEl.querySelector('.modal-dialog').classList.remove('closing');
        }, 500)
    });

	timerInterval.value = setInterval(() => {
		timer.value--;
	}, 1000);

});

const keepUserLoggedIn = async () => {
	await auth.FETCH_USER_DATA(true);
	await close();
}

const close = async () => {
    if (modal.value) {
        modal.value.hide();
    }
}

onUnmounted(() => {
	clearInterval(timerInterval.value);
	if (modal.value) {
		modal.value.dispose();
	}
});

defineExpose({
    close
});
</script>